import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../Flight/Flight.css';
import { GiClick } from "react-icons/gi";
import FlightDeal from './Flightdeal';

const flightsByRegion = [
  {
    region: "USA",
    destinations: [
      { id: "usa", city: "Orlando", economy: "£499" },
      { id: "usa", city: "New York", economy: "£399" },
      { id: "usa", city: "Las Vegas", economy: "£499" },
      { id: "usa", city: "Toronto", economy: "£389" },
      { id: "usa", city: "Vancouver", economy: "£529" }
    ]
  },
  {
    region: "Canada",
    destinations: [
      { id: "canada", city: "Calgary", economy: "£479" },
      { id: "canada", city: "Montreal", economy: "£529" },
      { id: "canada", city: "Halifax", economy: "£549" },
      { id: "canada", city: "Toronto", economy: "£389" },
      { id: "canada", city: "Vancouver", economy: "£529" }
    ]
  },
  {
    region: "Caribbean",
    destinations: [
      { id: "caribbean", city: "Antigua", economy: "£599" },
      { id: "caribbean", city: "Montego Bay", economy: "£549" },
      { id: "caribbean", city: "Kingston", economy: "£549" },
      { id: "caribbean", city: "Bridgetown", economy: "£579" },
      { id: "caribbean", city: "Nassau", economy: "£589" }
    ]
  },
  {
    region: "Australia and New Zealand",
    destinations: [
      { id: "a&n", city: "Auckland ", economy: "£699" },
      { id: "a&n", city: "Sydney ", economy: "£699" },
      { id: "a&n", city: "Melbourne ", economy: "£879" },
      { id: "a&n", city: "Perth", economy: "£799" },
      { id: "a&n", city: "Christchurch", economy: "£1199" }
    ]
  },
  {
    region: "Central America",
    destinations: [
      { id: "ca", city: "Mexico City", economy: "£799" },
      { id: "ca", city: "Cancun", economy: "£749" },
      { id: "ca", city: "Bogota", economy: "£845" },
      { id: "ca", city: "Punta Cana", economy: "£799" },
      { id: "ca", city: "Quito", economy: "£699" }
    ]
  },
  {
    region: "India",
    destinations: [
      { id: "india", city: "Delhi", economy: "£499" },
      { id: "india", city: "Mumbai", economy: "£495" },
      { id: "india", city: "Goa", economy: "£545" },
      { id: "india", city: "Chennai", economy: "£569" },
      { id: "india", city: "Banglore", economy: "£529" }
    ]
  },
  {
    region: "Far East",
    destinations: [
      { id: "fareast", city: "Manila ", economy: "£579" },
      { id: "fareast", city: "Seoul ", economy: "£689" },
      { id: "fareast", city: "Toyoko", economy: "£787" },
      { id: "fareast", city: "Beijing", economy: "£584" },
      { id: "fareast", city: "Singapore", economy: "£728" }
    ]
  },
  {
    region: "Middle East",
    destinations: [
      { id: "middleeast", city: "Abu Dhabi", economy: "£389" },
      { id: "middleeast", city: "Doha", economy: "£438" },
      { id: "middleeast", city: "Dubai", economy: "£376" },
      { id: "middleeast", city: "Muscat", economy: "£449" },
      { id: "middleeast", city: "Riyadh", economy: "£489" }
    ]
  }
];


const Flight = () => {
  const [selectedRegion, setSelectedRegion] = useState("USA");

  const handleRegionSelect = (region) => {
    setSelectedRegion(region);
  };
  const handleCall = () => {
    window.location.href = `tel:"02038852600"`;
};
  return (
    <>
      <div className="post-f">
        <div className="overlay-f">
          <h1 className="text-f">Our Popular Flights</h1>
        </div>
      </div>
      <FlightDeal/>
      <div className="flight-container-with-sidebar">
        {/* Sidebar */}
        <div className="flight-sidebar">
          <h3 className="sidebar-title">DESTINATIONS</h3>
          {flightsByRegion.map((regionData) => (
            <button
              key={regionData.region}
              className={`region-toggle ${selectedRegion === regionData.region ? 'active' : ''}`}
              onClick={() => handleRegionSelect(regionData.region)}
            >
              {regionData.region}
            </button>
          ))}
        </div>

        {/* Main content */}
        <div className="flight-main-content">
          <h2 className="flight-heading"> Incredible Flights</h2>
          
          {flightsByRegion.map((regionData) => (
            selectedRegion === regionData.region && (
              <div key={regionData.region} className="flight-region">
               
                <div className="flight-cards">
                  {regionData.destinations.map((destination) => (
                    <div key={destination.id} className="flight-cardd">
                      <h4>Flights To {destination.city}</h4>
                      <div className="flight-prices">
                        <span>Economy</span>
                        <span>from {destination.economy}</span>
                      </div>
                      <Link to={`/flight/${destination.id}`} className="flight-book-btn">
                        See Details
                      </Link>
                    </div>
                  ))}
                </div>
                

              </div>
            )
          ))}
          
        </div>
         <div className="flight-info">
         <div className="flight-support" onClick={handleCall}>
            <div className="support-header">HELP & SUPPORT</div>
            <div className="support-call">Call Us Now</div>
            <div className="support-number">+02038852600 <GiClick className='cli-i'/></div>
          </div>
           <div className="flight-logos">
             <img src="/flight.jpg" alt="flight-img" />
            
           </div>
          
           </div>
      </div>
     
    </>
  );
};

export default Flight;